import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import bitmapFonts from 'src/lib/bitmapFonts';
import View from '@play-co/timestep-core/lib/ui/View';
import ImageScaleView from '@play-co/timestep-core/lib/ui/ImageScaleView';
import sounds from 'src/lib/sounds';
import { animateCoins, animateEnergy } from '../../animation/CurrencyAnimation';
import { RewardDisplay } from 'src/game/components/RewardDisplay';

import { AssetGroup } from '@play-co/timestep-core';

export default class PopupLevelUPReward extends PopupBasic {
  private rewardDisplay: RewardDisplay;
  private coinAmount: number = 0;
  private energyAmount: number = 0;

  constructor(opts: { superview: View; close: () => void }) {
    super({
      superview: opts.superview,
      close: opts.close,
      zIndex: 10000,
      width: uiConfig.popups.minimumWidth,
      height: 410,
      tracking: { feature: 'level', $subFeature: 'popup-level-up-reward' },
    });

    this.buttonClose.removeFromSuperview();

    this.message.updateOpts({
      width: this.box.style.width - 80,
      height: 80,
      x: 40,
      y: 68,
      zIndex: 1,
      size: 40,
    });

    this.box.addSubview(
      new ImageScaleView({
        height: 5,
        width: this.message.style.width,
        x: 40,
        y: 132,
        image: 'assets/ui/popups/panel_underline.png',
        scaleMethod: '3slice',
        sourceSlices: {
          horizontal: { left: 5, right: 5 },
        },
      }),
    );

    this.rewardDisplay = new RewardDisplay({
      superview: this.box,
      x: this.box.style.width / 2,
      y: 212,
    });

    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...uiConfig.buttons.secondary,
        labelOffsetX: -4,
        labelOffsetY: -1,
        fontSize: 38,
        font: bitmapFonts('Body'),
        x: this.box.style.width / 2,
        y: this.box.style.height - 35 - 80 / 2,
        width: 229,
        height: 80,
        centerOnOrigin: true,
        localeText: () => i18n('basic.ok'),
        onClick: async () => {
          sounds.playSound('ok');
          await Promise.all([this.animateCoins(), this.animateEnergy()]);
          opts.close();
        },
        tracking: {
          feature: 'level',
          $subFeature: 'popup-level-up-reward-close',
        },
      }),
    );
  }

  protected getAssetsGroup() {
    return new AssetGroup(['assets/ui/popups/panel_underline.png']);
  }

  public init({
    level,
    reward,
    energyReward,
  }: {
    level: number;
    reward: number;
    energyReward?: number;
  }) {
    super.init({
      title: i18n('level.reward.title'),
      message: i18n('level.reward.message', { level }),
    });

    this.coinAmount = reward;
    this.energyAmount = energyReward || 0;

    sounds.playSound('applause');

    if (energyReward && energyReward > reward) {
      this.rewardDisplay.setIcon('energy');
      this.rewardDisplay.setReward(energyReward);
      return;
    }

    this.rewardDisplay.setReward(reward);
  }

  private async animateCoins() {
    const { icon: coinIcon } = this.rewardDisplay;
    const iconPos = coinIcon.getPosition(this.root);
    const start = {
      x: iconPos.x + coinIcon.style.width / 2,
      y: iconPos.y + coinIcon.style.height / 2,
    };

    await animateCoins({
      superview: this.root,
      start: { position: start, scale: 1 },
      count: this.coinAmount,
    });
  }

  private async animateEnergy() {
    if (!this.energyAmount) return;

    const { icon: coinIcon } = this.rewardDisplay;
    const iconPos = coinIcon.getPosition(this.root);
    const start = {
      x: iconPos.x + coinIcon.style.width / 2,
      y: iconPos.y + coinIcon.style.height / 2,
    };

    await animateEnergy({
      superview: this.root,
      start: { position: start, scale: 1 },
      count: this.energyAmount,
    });
  }
}
